__webpack_require__.p = "https://festatic.playgami.scopely.com/portal-navigation/v5_24_1/";